import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { PieChart } from 'lucide-react';

const getStatusColor = (status) => {
  const colors = {
    'Funded': 'text-green-600',
    'Payment Issues': 'text-yellow-600',
    'In-House Collection': 'text-orange-600',
    'Default': 'text-red-600',
    'Collected': 'text-blue-600',
    'Paid in Full': 'text-purple-600'
  };
  return colors[status] || 'text-gray-600';
};

const PortfolioStatusBreakdown = ({ metrics }) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center">
          <PieChart className="h-5 w-5 mr-2" />
          Deal Status Breakdown
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {Object.entries(metrics.statusCounts || {}).map(([status, count]) => (
            <div key={status} className="text-center p-4 bg-gray-50 rounded-lg">
              <div className={`text-3xl font-bold ${getStatusColor(status)}`}>{count}</div>
              <p className="text-sm text-gray-600 mt-1">{status}</p>
              <p className="text-xs text-gray-500">
                {metrics.totalDeals > 0 ? ((count / metrics.totalDeals) * 100).toFixed(1) : 0}%
              </p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default PortfolioStatusBreakdown;
